import type { FactsheetDetails, RelatedCode } from '@/features/factsheet';
import RelatedCodeList from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/RelatedCodesTab/RelatedCodeList';

const isLive = (relatedCode: RelatedCode) => (relatedCode.status ?? 'Live') === 'Live';

const RelatedCodesTab = ({
  factsheet,
  openNewTab
}: {
  factsheet: FactsheetDetails;
  openNewTab: (code: string) => void;
}) => (
  <div>
    <RelatedCodeList
      openNewTab={openNewTab}
      relatedCodes={factsheet.parentCodes?.filter(isLive)}
      title='Parent Codes'
    />
    <RelatedCodeList
      openNewTab={openNewTab}
      relatedCodes={factsheet.childCodes?.filter(isLive)}
      title='Child Codes'
    />
  </div>
);

export default RelatedCodesTab;
